<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Monthly_Uploads_Title' | translateWF: 'Monthly Uploads' }}</h1>
        <div class="page__title_buttons"></div>
      </div>
    </div>

    <p-selectbutton [options]="sections" [formControl]="selectedSection" optionLabel="label" optionValue="value" [unselectable]="false" />

    @switch (selectedSection.value) {
      @case (1) {
        <app-employee-costs-tab />
      }
      @case (2) {
        <app-asset-depreciation-tab />
      }
      @case (3) {
        <app-service-costs-tab />
      }
    }
  </div>
</main>
